import styled from 'styled-components';

export const Check = styled.span`
  flex-grow: 1;
  justify-content: flex-end;
  display: inline-flex;
  width: 34px;
`;
